import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import Contact from '@/pages/Contact';
import Feedback from '@/pages/Feedback';
import FrequentlyAskedQuestions from '@/pages/FrequentlyAskedQuestions';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import store from '../store';
import RequestTrial from '../components/RequestTrial';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {title: 'Bionic Metrics', hideOnScroll: true}
  }, {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {title: 'Contact'}
  }, {
    path: '/request-trial',
    name: 'Request Trial',
    component: RequestTrial,
    meta: {title: 'Request Trial'}
  }, {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: {title: 'Feedback'}
  }, {
    path: '/faq',
    name: 'Frequently Asked Questions',
    component: FrequentlyAskedQuestions,
    meta: {title: 'FAQs'}
  }, {
    path: '/terms',
    name: 'Terms of Service',
    component: Terms,
    meta: {title: 'Terms'}
  }, {
    path: '/privacy',
    name: 'Privacy Policy',
    component: Privacy,
    meta: {title: 'Privacy'}
  }],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {x: 0, y: 0};
  }
});
router.beforeEach((to, from, next) => {
  document.title = to.name;
  store.commit('setTitle', to.meta.title);
  store.commit('setHideOnScroll', !!to.meta.hideOnScroll);
  next();
});

export default router;
